import React from "react";
import styled from "styled-components";
import AutoLayout from "../Layouts/AutoLayout/AutoLayout";
import {
  AutoLayoutAlignEnum,
  AutoLayoutDirectionEnum,
  AutoLayoutResizingEnum,
} from "../Layouts/AutoLayout/AutoLayoutEnums";
import { ThemeColorEnum } from "../Themes/ThemeEnums";
import { ITheme } from "../Themes/ThemeTypes";

const Divider = styled.div<{ theme: ITheme }>`
  width: 100%;
  height: 1px;
  background-color: rgba(${(props) => props.theme.colors.on_surface}, 0.12);
`;

interface ListProps {
  children: React.ReactNode;
  dividers?: boolean;
}

const List: React.FC<ListProps> = ({ children, dividers }) => (
  <AutoLayout
    $direction={AutoLayoutDirectionEnum.VERTICAL}
    $horizontalResizing={AutoLayoutResizingEnum.FILL}
    $verticalResizing={AutoLayoutResizingEnum.FILL}
    $align={AutoLayoutAlignEnum.TOP_CENTER}
    $topPadding={8}
    $bottomPadding={8}
    $backgroundColor={ThemeColorEnum.SURFACE}
  >
    {dividers
      ? React.Children.toArray(children).map((child, index) => (
          <React.Fragment key={index}>
            {index > 0 && <Divider />}
            {child}
          </React.Fragment>
        ))
      : children}
  </AutoLayout>
);

export default List;
